<div class="star-rating" [ngClass]="{'stabled':(stableValue>0)}">
    <span *ngFor="let item of starList, let i = index" (mouseover)="mouseEnter(i,  $event)" (mousemove)="mouseMove(i,  $event)" (mouseout)="mouseLeave()" (click)="selectNewRate(i, $event)">
		<mat-icon *ngIf="item.starType === starType.Full" matTooltipClass="mat-tool-tip-custom" [matTooltipDisabled]="stableValue>0" [matTooltip]="(i+1)">star
		</mat-icon>
		<mat-icon class="empty" *ngIf="item.starType === starType.Empty">star_border</mat-icon>
		<mat-icon class="half" *ngIf="item.starType === starType.Half" matTooltipClass="mat-tool-tip-custom" [matTooltipDisabled]="stableValue>0"
			[matTooltip]="(i+.5)">star_half</mat-icon>
	</span>

</div>